import GridTextCell from './GridTextCell';
import GridDateCell from './GridDateCell';
import GridItemsCell from './GridItemsCell';
import GridStatusCell from './GridStatusCell';
import EditorSelectCell from './EditorSelectCell';
import GridSelectCell from './GridSelectCell';
import GridStateCell from './GridStateCell';
import GridAmountCell from './GridAmountCell';
import GridPhoneCell from './GridPhoneCell';
import GridPercentCell from './GridPercentCell';
import GridSelectObjectCell from './GridSelectObjectCell';
import GridMultipleItemsCell from './GridMultipleItemsCell';
import GridEnableCell from './GridEnableCell';
import GridCryptoAmountCell from './GridCryptoAmountCell';
import GridUrlCell from './GridUrlCell';
import GridLinkCell from './GridLinkCell';
import GridCheckboxCell from './GridCheckboxCell';
import GridEntityCell from './GridEntityCell';
import GridCreateModifyCell from './GridCreateModifyCell';
import GridSelectCombinedCell from './GridSelectCombinedCell';
import GridNumberCell from './GridNumberCell';
import GridArrayCell from './GridArrayCell';
import GridEditableBoolean from './GridEditableBoolean';
import GridDateTimeCell from './GridDateTimeCell';
import GridBalanceCell from './GridBalanceCell';
import GridUploadCell from './GridUploadCell';
import GridDiffCell from './GridDiffCell';
import GridTagsCell from './GridTagsCell';
import GridJsonCell from './GridJsonCell';

const Cells = {
    Text: GridTextCell,
    Date: GridDateCell,
    DateTime: GridDateTimeCell,
    CreateModify: GridCreateModifyCell,
    State: GridStateCell,
    Items: GridItemsCell,
    Select: GridSelectCell,
    Status: GridStatusCell,
    Checkbox: GridCheckboxCell,
    // Boolean columns (isArchived, syncEnabled, locked…) had no renderer, fell
    // back to the text cell and rendered true/false as nothing.
    Boolean: GridCheckboxCell,
    Amount: GridAmountCell,
    Phone: GridPhoneCell,
    Percent: GridPercentCell,
    EditorSelect: EditorSelectCell,
    SelectObject: GridSelectObjectCell,
    Countries: GridMultipleItemsCell,
    Enable: GridEnableCell,
    CryptoAmount: GridCryptoAmountCell,
    Url: GridUrlCell,
    // A row of another grid, opened searching for it (the field's `linkTo`).
    Link: GridLinkCell,
    Entity: GridEntityCell,
    SystemRole: GridCheckboxCell,
    SelectCombined: GridSelectCombinedCell,
    Number: GridNumberCell,
    ContextMultiSelect: GridArrayCell,
    // A fixed list's values, picked any number at a time: shown as tags,
    // translated as Items values are.
    StaticMultiSelect: GridTagsCell,
    EditableBoolean: GridEditableBoolean,
    RoleSelect: GridSelectCombinedCell,
    Balance: GridBalanceCell,
    Upload: GridUploadCell,
    Diff: GridDiffCell,
    Tags: GridTagsCell,
    Json: GridJsonCell,
    // The editor gives Secret a generate button; the grid has nothing
    // special to do with one. Present so the lookup cannot miss.
    Secret: GridTextCell,
    // Only the editor differs from Json (a Scenarios mode); the grid shows the
    // same JSON preview.
    ScraperSettingsJson: GridJsonCell,
    GatewaySettings: GridJsonCell,
    WalletRequisites: GridJsonCell,
    // File holds a picked file only until a dialog sends it, so no grid shows
    // one. Present so the lookup cannot miss.
    File: GridTextCell,
    // Only the editor differs from BigText (the rule language's help); the grid
    // shows the rule's text. Present so the lookup cannot miss.
    WalletRule: GridTextCell,
    GatewayRule: GridTextCell,
    WalletOrder: GridTextCell,
};

export default Cells;
